"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addFontSizeSelects = addFontSizeSelects;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _hsformatting = require("tinymce-plugins/constants/hsformatting");

var _utils = require("../utils");

var _toolbar = require("../constants/toolbar");

var _usageTracking = require("../constants/usageTracking");

var _TinyMceFontSize = _interopRequireDefault(require("../components/toolbar/TinyMceFontSize"));

var _hsformatting2 = require("../constants/hsformatting");

var _usageTracking2 = require("../utils/usageTracking");

var _utils2 = require("./utils");

var _getComputedStyle = require("../utils/getComputedStyle");

var _i18n = require("../utils/i18n");

var i18nKey = (0, _i18n.i18nWithNameSpace)(_hsformatting2.i18nNameSpace);
var fontSizeSelectMenuItem = 'fontSizeSelectMenuItem';

function registerBlockFontSize(_ref) {
  var editor = _ref.target;
  editor.formatter.register(_hsformatting2.BLOCK_FONT_SIZE_FORMAT, {
    selector: _hsformatting2.FONT_SIZE_BLOCKS.join(','),
    styles: {
      fontSize: '%value'
    }
  });
}

function createFontSizeChangeHandler(items, editor) {
  return function (_ref2) {
    var control = _ref2.control;
    editor.on('nodeChange', function (event) {
      var computedStyle = (0, _getComputedStyle.maybeGetComputedStyle)(editor.getWin(), event.element);

      if (!computedStyle) {
        return;
      }

      var fontSize = computedStyle['font-size'];
      var matched = items.find(function (item) {
        return item.value === fontSize;
      });

      if (matched) {
        control.value(matched.value);
      } else {
        control.value(null);
      }
    });
  };
}

function createFontSizeSelectMenu(editor) {
  var fontSizeSelectMenuOnClick = function fontSizeSelectMenuOnClick(event) {
    var format = event.control.settings.format;

    if (format) {
      editor.execCommand('hsfontsize', false, {
        value: format
      });
      (0, _usageTracking2.trackInteraction)(editor, 'tinymceFormatting', _usageTracking.CHANGE_FONT_SIZE, {
        method: 'menu',
        value: format
      });
    }
  };

  var fontsizeFormats = (0, _utils.getHsformattingSettings)(editor.settings, _hsformatting.hsformattingConfig.FONT_SIZE_FORMATS, []);
  return fontsizeFormats.map(function (item) {
    return {
      text: item,
      format: item + "px",
      onclick: fontSizeSelectMenuOnClick
    };
  });
}

function addFontSizeSelects(editor) {
  var fontSizes = (0, _utils.getHsformattingSettings)(editor.settings, _hsformatting.hsformattingConfig.FONT_SIZE_FORMATS, []);
  var items = fontSizes.map(function (fontSize) {
    return {
      text: {
        raw: fontSize + "px"
      },
      value: fontSize + "px"
    };
  });
  editor.on('PreInit', registerBlockFontSize);
  editor.addCommand('hsFontSize', function (command, _ref3) {
    var value = _ref3.value;
    (0, _utils2.applyFontSize)(editor, value);
  });
  editor.addMenuItem('fontsizeselect', {
    text: i18nKey(fontSizeSelectMenuItem),
    menu: createFontSizeSelectMenu(editor)
  });
  editor.addButton('fontsizeselect', function () {
    return {
      type: 'listbox',
      text: i18nKey(fontSizeSelectMenuItem),
      tooltip: i18nKey(fontSizeSelectMenuItem),
      values: items,
      fixedWidth: true,
      onPostRender: createFontSizeChangeHandler(items, editor),
      onselect: function onselect(event) {
        var format = event.control.settings.value;

        if (format) {
          editor.execCommand('hsfontsize', false, {
            value: format
          });
          (0, _usageTracking2.trackInteraction)(editor, 'tinymceFormatting', _usageTracking.CHANGE_FONT_SIZE, {
            method: 'button',
            value: format
          });
        }
      }
    };
  });
  editor.addButton('canvasfontsizeselect', function () {
    return {
      type: _toolbar.CANVAS_BUTTON_TYPE,
      renderControl: function renderControl(props) {
        return _react.default.createElement(_TinyMceFontSize.default, (0, _extends2.default)({
          editor: editor,
          placeholder: i18nKey(fontSizeSelectMenuItem),
          fontSizes: items.map(function (_ref4) {
            var text = _ref4.text.raw,
                value = _ref4.value;
            return {
              text: text,
              value: value
            };
          })
        }, props));
      }
    };
  });
}